export const LABELS_CHIPS_DAID = 'labels-chips';
